"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var uuid = require("uuid/v4");
var serializr_1 = require("serializr");
var PixelDimensions = /** @class */ (function () {
    function PixelDimensions() {
    }
    tslib_1.__decorate([
        serializr_1.serializable
    ], PixelDimensions.prototype, "width", void 0);
    tslib_1.__decorate([
        serializr_1.serializable
    ], PixelDimensions.prototype, "height", void 0);
    return PixelDimensions;
}());
var Attachment = /** @class */ (function () {
    function Attachment(attachment) {
        this.id = attachment.id || uuid();
        this.uri = attachment.uri;
        this.mediaType = attachment.mediaType;
        this.mimeType = attachment.mimeType;
        this.pixelDimensions = attachment.pixelDimensions || {};
    }
    tslib_1.__decorate([
        serializr_1.serializable
    ], Attachment.prototype, "id", void 0);
    tslib_1.__decorate([
        serializr_1.serializable
    ], Attachment.prototype, "mimeType", void 0);
    tslib_1.__decorate([
        serializr_1.serializable
    ], Attachment.prototype, "uri", void 0);
    tslib_1.__decorate([
        serializr_1.serializable
    ], Attachment.prototype, "mediaType", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(PixelDimensions))
    ], Attachment.prototype, "pixelDimensions", void 0);
    return Attachment;
}());
exports.Attachment = Attachment;
//# sourceMappingURL=Attachment.js.map